export const MARK_COMMENT_AS_READ = 'features.markable-as-read.mark-comment-as-read';
